import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Calendar from "../Calendar/Calendar";
import { subscriptionCalendarAction } from "../../redux/rootReducer";
import { addRecordThunk } from "../../redux/thunks/addRecordThunk";
import { SUBSCRIPTION_CALENDAR_INITIAL } from "../../redux/initialStateConstant";
import { getDates } from "../../helpers/getDates";

const SubscriptionCalendar = ({ date }) => {
    const dispatch = useDispatch();
    const subscriptionCalendar = useSelector(state => state.subscriptionCalendar);

    // Если не передана дата, или дата пустая строка
    if (!date) {
        date = new Date().toLocaleDateString('fr-CA');
    }

    const [dates, setDates] = useState({});

    // Переключение месяца
    const changeMonth = d => {
        setDates(getDates(d));
    };

    useEffect(() => {
        setDates(getDates(date));
    }, [date]);

    if (!subscriptionCalendar.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <Calendar
                        dates={ dates.days }
                        title={ dates.monthYear }
                        today={ dates.today }
                        navs={ true }
                        prevHandler={ () => changeMonth(dates.prev) }
                        nextHandler={ () => changeMonth(dates.next) }
                        dayHandler={ date => dispatch(addRecordThunk({
                            subscription_id: subscriptionCalendar.subscription_id,
                            date: date.date
                        })) }
                        close={ () => {
                            dispatch(subscriptionCalendarAction(SUBSCRIPTION_CALENDAR_INITIAL));
                            setDates(getDates(dates.today));
                        } }
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCalendar;